import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map, filter } from 'rxjs/operators';
import { GetSubscriptionSuccess } from '../../subscription/action-creators';
import { GET_SUBSCRIPTION_SUCCESS } from '../../subscription/actions';

export const identifyArtistPlanEpic = (action$: Observable<GetSubscriptionSuccess>) =>
  action$.pipe(
    ofType(GET_SUBSCRIPTION_SUCCESS),
    map((action) => {
      if (window.analytics) {
        window.analytics.group(action.subscription.clientId , {
          plan: action.subscription.plan,
          planFrequency: action.subscription.frequency
        });
      }
    }),
    filter(() => false)
  )